// Whether a consumer member is held behind the paywall. THE ONE COPY of the rule: the BFF's
// `subscription.getStatus` answers with it (`paywalled`), and the SPA's `useIsPaywalled` reads that
// field rather than looking at a status itself. The only other caller is the dev tools' status
// override, which has to hand the gate a verdict for a status the BFF never sent.
//
// Two storefronts, two sources of truth:
//   - external (UHC and the like) — the member paid the partner, not Stripe, so they have no Stripe
//     subscription and Convex always answers `none` for them. carrot-app's `consumerSubscription.state`
//     is the record: only `current` is let through.
//       · `lapsed` is walled. Login already hands a lapsed external member back to their storefront
//         (LoginContainer), so the wall only meets one whose session was restored instead.
//       · `registration_incomplete` is walled, but `ExternalRegistrationGuard` sends that member to
//         the registration resume page before the gate ever mounts.
//       · `payment_required` is walled, the same as an unpaid cash-pay member.
//   - carrot (our own Stripe store), and any member carrot-app sends no `consumerSubscription` for —
//     the Stripe status Convex mirrors: only `active` is let through. A `consumerSubscription` the BFF
//     cannot parse (a state CI adds later) also lands here, which is the pre-storefront behaviour.
//
// Failing open on an unreadable answer is NOT here: it's the caller's job, because only the caller
// knows the read failed.

export type PaywallFacts = {
  /** carrot-app's `consumerSubscription.storefront.type`; absent when carrot-app sent none. */
  storefront?: "carrot" | "external"
  /** carrot-app's `consumerSubscription.state`. */
  consumerState?: "current" | "registration_incomplete" | "payment_required" | "lapsed"
  /** Convex's mirror of the Stripe subscription. */
  stripeStatus: "none" | "unpaid" | "active" | "lapsed"
}

export function isPaywalled({ storefront, consumerState, stripeStatus }: PaywallFacts): boolean {
  if (storefront === "external") return consumerState !== "current"
  return stripeStatus !== "active"
}
